import * as types from "../constant/ActionType";

const initialState = {
  CurrencyData: [],
};

// Normalize is_active from boolean (API returns true/false) to integer (UI uses 1/0)
const toInt = (val) => (val === true || val === 1 ? 1 : 0);

const AllCurrencies = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_CURRENCIES: {
      const raw = Array.isArray(action.data)
        ? action.data
        : action.data?.data || action.data?.currencies || [];
      // Normalize is_active so all downstream === 1 checks work correctly
      const list = raw.map((c) => ({ ...c, is_active: toInt(c.is_active) }));
      return {
        ...state,
        CurrencyData: list,
      };
    }

    case types.ADD_CURRENCY: {
      const newItem = action.data?.formData;
      if (!newItem) return state;
      return {
        ...state,
        CurrencyData: [
          ...state.CurrencyData,
          {
            id: newItem.id,
            currency_code: newItem.currency_code,
            currency_description: newItem.currency_description,
            currency_iso_code: newItem.currency_iso_code,
            is_active: toInt(newItem.is_active ?? 1),
          },
        ],
      };
    }

    case types.EDIT_CURRENCY: {
      const updatedItem = action.data?.formData;
      if (!updatedItem) return state;
      return {
        ...state,
        CurrencyData: state.CurrencyData.map((c) =>
          (updatedItem.id && c.id === updatedItem.id) ||
          c.currency_code === updatedItem.currency_code
            ? {
                ...c,
                ...updatedItem,
                is_active: toInt(updatedItem.is_active ?? c.is_active),
              }
            : c
        ),
      };
    }

    case types.DELETE_CURRENCY: {
      const itemToDelete = action.data?.formData;
      if (!itemToDelete) return state;
      return {
        ...state,
        // Optimistically toggle status — server re-fetch will confirm the real DB state
        CurrencyData: state.CurrencyData.map((c) => {
          if (
            (c.id && itemToDelete.id && c.id === itemToDelete.id) ||
            c.currency_code === itemToDelete.currency_code
          ) {
            return { ...c, is_active: c.is_active === 1 ? 0 : 1 };
          }
          return c;
        }),
      };
    }

    case types.UPDATE_STATUS_CURRENCY: {
      const itemToUpdate = action.data?.formData;
      if (!itemToUpdate) return state;
      return {
        ...state,
        CurrencyData: state.CurrencyData.map((c) =>
          (itemToUpdate.id && c.id === itemToUpdate.id) ||
          c.currency_code === itemToUpdate.currency_code
            ? { ...c, is_active: c.is_active === 1 ? 0 : 1 }
            : c
        ),
      };
    }

    default:
      return state;
  }
};

export default AllCurrencies;
